import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Chip from '@material-ui/core/Chip';
import translations from './translations';

const StatusFormatter = ({ isExpired }) => {
  const intl = useIntl();

  return (
    <Chip
      component="div"
      label={intl.formatMessage(translations.statuses[isExpired ? 'expired' : 'open'])}
      color={isExpired ? 'default' : 'primary'}
      variant={isExpired ? 'default' : 'outlined'}
    />
  );
};

StatusFormatter.propTypes = {
  isExpired: PropTypes.bool,
};

StatusFormatter.defaultProps = {
  isExpired: false,
};

export default StatusFormatter;
